import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { AnimatedEmailBanner } from 'bigmailer/AnimatedEmailBanner.component';
import cn from 'classnames';

import ExternalLink from 'components/generic/ExternalLink.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './EmailsInfo.module.scss';

const EmailsInfo = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const { emailBlastHowToStartHelpLink, emailBlastDesignHelpLink } = useHelpLinks();

  return (
    <div
      data-bem="EmailsInfo"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <div data-bem="EmailsInfo__anime--banner" className={CN.bannerContainer}>
          <AnimatedEmailBanner />
        </div>
        <div data-bem="EmailsInfo__info" className={CN.infoBlock}>
          <div className={CN.infoTitle}>{t('clientsEmailPage.emailsInfo.description')}</div>
          <div className={CN.point}>
            <CheckCircleIcon className={CN.checkIcon} />
            {t('clientsEmailPage.emailsInfo.bullet1')}
          </div>
          <div className={CN.point}>
            <CheckCircleIcon className={CN.checkIcon} />
            <div>
              <span className={CN.bold}>{t('clientsEmailPage.emailsInfo.bullet2.part1')} </span>
              {t('clientsEmailPage.emailsInfo.bullet2.part2')} <CurrencySign />
              {t('clientsEmailPage.emailsInfo.bullet2.part3')}
            </div>
          </div>
          <div className={CN.point}>
            <CheckCircleIcon className={CN.checkIcon} />
            {t('clientsEmailPage.emailsInfo.bullet3')}
          </div>
          <div className={CN.linkContainer}>
            <ExternalLink tag="EmailsInfo__link" link={emailBlastHowToStartHelpLink}>
              <span className={CN.articleLink}>{t('clientsEmailPage.emailsInfo.howToStartLink')}</span>
            </ExternalLink>
            <ExternalLink tag="EmailsInfo__link" link={emailBlastDesignHelpLink}>
              <span className={CN.articleLink}>{t('clientsEmailPage.emailsInfo.templatesLink')}</span>
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailsInfo;
